import { combineReducers, createAction } from '@reduxjs/toolkit';

import { broadcastReducer } from './features/broadcast/slice';
import { chatReducer } from './features/chat';
import { cloudRecordingReducer } from './features/cloud-recording';
import { conferenceReducer } from './features/conference/slice';
import { deviceReducer } from './features/device/slice';
import { fullscreenReducer } from './features/fullscreen/';
import { videoGridReducer } from './features/goloom-video-grid';
import { networkQualityReducer } from './features/network-quality/slice';
import { offlineReducer } from './features/offline/slice';
import { participantsSearchReducer } from './features/participants-search';
import { permissionsReducer } from './features/permissions';
import { recordReducer } from './features/record';
import { screenSharingReducer } from './features/screen-sharing/slice';
import { shareLinkReducer } from './features/share-link/slice';
import { sidebarReducer } from './features/sidebar/slice';
import { summarizationReducer } from './features/summarization';
import { waitingRoomsReducer } from './features/waiting-rooms/slice';
import { messengerReducer } from './iframe-sagas/slice';

const callReducer = combineReducers({
    conference: conferenceReducer,
    messenger: messengerReducer,
    offline: offlineReducer,
    networkQuality: networkQualityReducer,
    screenSharing: screenSharingReducer,
    videoGrid: videoGridReducer,
    record: recordReducer,
    sidebar: sidebarReducer,
    chat: chatReducer,
    fullscreen: fullscreenReducer,
    broadcast: broadcastReducer,
    permissions: permissionsReducer,
    device: deviceReducer,
    shareLink: shareLinkReducer,
    waitingRooms: waitingRoomsReducer,
    cloudRecording: cloudRecordingReducer,
    summarization: summarizationReducer,
    participantsSearch: participantsSearchReducer,
});

export const resetCall = createAction('conference/resetCall');

export default callReducer;
